// extracted by mini-css-extract-plugin
export var footer = "Home-module__footer--hmOp7";
export var pageControls = "Home-module__page-controls--jf8dW";
export var studyCount = "Home-module__study-count---75Q1";